module.exports = __webpack_public_path__ + "img/facial_hair_chin_mustache_thick_rect_mask.b6162e47.png";